import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconLightMode24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="light mode">
            <path
                d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11 4V2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11 22V20C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M4.22297 4.22297C4.61349 3.83244 5.24651 3.83244 5.63703 4.22297L7.04719 5.63312C7.43756 6.02366 7.43766 6.65671 7.04719 7.04719C6.65671 7.43766 6.02366 7.43756 5.63312 7.04719L4.22297 5.63703C3.83244 5.24651 3.83244 4.61349 4.22297 4.22297Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M16.953 16.953C17.3435 16.5624 17.9765 16.5624 18.367 16.953L19.7772 18.3631C20.1676 18.7537 20.1677 19.3867 19.7772 19.7772C19.3867 20.1677 18.7537 20.1676 18.3631 19.7772L16.953 18.367C16.5624 17.9765 16.5624 17.3435 16.953 16.953Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M4 11C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M22 11C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H20C19.4477 13 19 12.5523 19 12C19 11.4477 19.4477 11 20 11H22Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M5.63312 16.953C6.02366 16.5625 6.65669 16.5625 7.04719 16.953C7.43761 17.3435 7.43761 17.9765 7.04719 18.367L5.63703 19.7772C5.24653 20.1676 4.61347 20.1676 4.22297 19.7772C3.83247 19.3867 3.83252 18.7537 4.22297 18.3631L5.63312 16.953Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M18.3631 4.22297C18.7537 3.83252 19.3867 3.83247 19.7772 4.22297C20.1676 4.61347 20.1676 5.24653 19.7772 5.63703L18.367 7.04719C17.9765 7.43761 17.3435 7.43761 16.953 7.04719C16.5625 6.65669 16.5625 6.02366 16.953 5.63312L18.3631 4.22297Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
